// Developers — currently gated. The programmatic API, developer pricing,
// and API-key issuance are not available yet. Leaving the page and the
// navigation entry in place so interested users can see what's coming and
// register their email for early access.

export default function Developers() {
  return (
    <>
      <section className="hero-gradient py-5">
        <div className="container py-4">
          <div className="text-center text-white">
            <span className="badge bg-warning text-dark px-3 py-2 mb-3" style={{ fontSize: '0.82rem' }}>
              <i className="fas fa-clock me-1"></i>Coming soon
            </span>
            <h1 style={{ fontWeight: 800, fontSize: '2.6rem' }}>Developer API</h1>
            <p className="lead" style={{ color: 'rgba(255,255,255,0.85)', maxWidth: 720, margin: '0 auto' }}>
              Generate dissertations, assignments and time-series analyses from your own apps.
              We're polishing the programmatic endpoints right now — early-access accounts with
              free starter credits will open shortly.
            </p>
          </div>
        </div>
      </section>

      <div className="main-container">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card">
              <div className="card-body text-center py-5">
                <div
                  style={{
                    width: 72,
                    height: 72,
                    borderRadius: 18,
                    background: 'linear-gradient(135deg, var(--primary), var(--secondary))',
                    color: '#fff',
                    display: 'inline-grid',
                    placeItems: 'center',
                    fontSize: '1.8rem',
                    marginBottom: '1.2rem',
                  }}
                >
                  <i className="fas fa-code"></i>
                </div>
                <h4 className="fw-bold mb-3">Developer accounts are not yet open.</h4>
                <p className="text-muted" style={{ maxWidth: 520, margin: '0 auto 1.5rem' }}>
                  We're finalising wholesale pricing (K50 per assignment, K500 per
                  dissertation), API-key issuance, and sandbox access. When it launches,
                  approved early-access accounts will receive complimentary starter
                  credits to test the integration.
                </p>
                <a
                  href="mailto:silas.phiri21@gmail.com?subject=Developer%20API%20early%20access"
                  className="btn btn-cta"
                >
                  <i className="fas fa-envelope me-1"></i>Request early access
                </a>
                <div className="small text-muted mt-3">
                  Or email us directly: <a href="mailto:silas.phiri21@gmail.com">silas.phiri21@gmail.com</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
